export type ContactPayload = {
  name: string;
  email: string;
  message: string;
  budgetRange?: string;
};

export type ContactResult = {
  ok: boolean;
  message: string;
};

/**
 * sendContactRequest
 * Front-end helper that posts to /api/contact and gracefully degrades if the backend is unavailable.
 * Replace the fetch endpoint or success heuristic once a real integration is wired up.
 */
export async function sendContactRequest(payload: ContactPayload): Promise<ContactResult> {
  try {
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error("Failed to send message");
    }

    return { ok: true, message: "Message queued successfully." };
  } catch (error) {
    console.warn("[contact] Pending backend integration. Falling back to mock response.", error);
    return {
      ok: false,
      message: "Offline mode: backend not connected. Please email contact@enkae.dev."
    };
  }
}

